import { useEffect, useState } from "react";
import { postAPIHandler } from "../../../Api/api";

const TeamRanking = ({ formatTypes }) => {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    (async () => {
      const formData = new FormData();
      formData.append(
        "type",
        formatTypes === "ODI" ? 1 : formatTypes === "Test" ? 2 : 3
      );

      const { data } = await postAPIHandler("teamRanking", formData);

      setTeams(
        Array.isArray(data)
          ? [...new Map(data.map(t => [`${t.rank}-${t.team}`, t])).values()]
              .sort((a, b) => a.rank - b.rank)
          : []
      );
    })();
  }, [formatTypes]);

  return (
    <div className="teamRanking-table">
      <div className="flex flex-wrap justify-between bg-[linear-gradient(90.3deg,#AF6B16_0.16%,#F8DF65_50.89%,#DC9A2B_101.62%)] py-3 rounded-lg lg:px-[10%] px-[5%]">
        {["Rank", "Team", "Rating", "Points"].map(h => (
          <span key={h} className={h === "Rank" ? "rank-field" : h === "Team" ? "teamName-field" : ""}>
            {h}
          </span>
        ))}
      </div>

      {teams.map(({ rank, team, rating, point }) => (
        <div
          key={`${rank}-${team}`}
          className="flex flex-wrap justify-between py-3 rounded-lg mt-2 bg-[#232525] hover:bg-[#393c3c] lg:px-[10%] px-[5%]"
        >
          <span className="rank-field">{rank}</span>
          <span className="teamName-field">{team}</span>
          <span>{rating}</span>
          <span>{point}</span>
        </div>
      ))}
    </div>
  );
};

export default TeamRanking;
